import { Component, EventEmitter, inject, Input, OnChanges, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { KpisByCategory, Message, Segment, Study, StudyMilestones } from '@models';
import { StudyInsightsService, StudyService } from '@services';
import { map, Observable, of } from 'rxjs';

import { WINDOW } from '../../../core/window.token';

@Component({
  selector: 'ai-summary-variants',
  templateUrl: './ai-summary-variants.component.html',
  styleUrl: './ai-summary-variants.component.scss'
})
export class AiSummaryVariantsComponent implements OnInit, OnChanges {
  router = inject(Router);
  route = inject(ActivatedRoute);
  studyInsightsService: StudyInsightsService = inject(StudyInsightsService);
  studyService: StudyService = inject(StudyService);
  mWindow = inject(WINDOW);

  @Input() milestones: StudyMilestones | undefined;
  @Input() kpis: KpisByCategory | undefined;
  @Output() termClicked = new EventEmitter<Record<string, any>>();

  selectedStudySk: string | null = null;
  studies: Observable<Study[]> = this.studyService
    .getStudiesPortfolio(this.studyService.getClientNamesList())
    .pipe(
      map((studies) =>
        studies.sort((a, b) => {
          const nameCompare = a.clientName.localeCompare(b.clientName);
          if (nameCompare !== 0) return nameCompare;

          return a.protocolNumber.localeCompare(b.protocolNumber);
        })
      )
    );

  studySummaryOne: Observable<string | Segment[]> = of('Loading...');
  studySummaryTwo: Observable<string | Segment[]> = of('Loading...');
  studySummaryThree: Observable<string | Segment[]> = of('Loading...');

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.selectedStudySk = params['studySk'];
    });
  }

  ngOnChanges() {
    if (this.milestones && this.kpis) {
      this.studySummaryOne = this.studyInsightsService
        .getStudyInsights(this.milestones, this.kpis, 'studyinsights')
        .pipe(map((res) => this.mapResponseState(res)));
      this.studySummaryTwo = this.studyInsightsService
        .getStudyInsights(this.milestones, this.kpis, 'studyinsightsv2')
        .pipe(map((res) => this.mapResponseState(res)));
      this.studySummaryThree = this.studyInsightsService
        .getStudyInsights(this.milestones, this.kpis, 'studyinsightsv3')
        .pipe(map((res) => this.mapResponseState(res)));
    }
  }

  private mapResponseState(
    insights: { status: 'success'; data: Message[] } | { status: 'error'; errorCode: number }
  ) {
    if (insights.status === 'success') {
      return insights.data[1]?.content ?? 'No study insights available at this time.';
    } else {
      return 'No study insights available at this time.';
    }
  }

  onStudyChange(event: Event) {
    const studySk = (event.target as HTMLInputElement).value;
    this.router.navigate(['/portfolio/study-details/', studySk]).then(() => {
      this.mWindow.location.reload();
    });
  }

  onTermClicked($event: Record<string, any>) {
    this.termClicked.emit($event);
  }
}
